import type { Meta, StoryFn } from '@storybook/react';
import type { PeriodsProps } from './Periods';

import { Periods } from './Periods';

const codeString = '<Periods periods={periods} />';

const PERIODS = [
  {
    id: '2023P1',
    number: 1,
    semesterNumber: 1,
    periodInSemester: 1,
  },
  {
    id: '2023P2',
    number: 2,
    semesterNumber: 1,
    periodInSemester: 2,
  },
  {
    id: '2023P3',
    number: 3,
    semesterNumber: 1,
    periodInSemester: 3,
  },
  {
    id: '2023P5',
    number: 5,
    semesterNumber: 2,
    periodInSemester: 2,
  },
  {
    id: '2023P7',
    number: 7,
    semesterNumber: 3,
    periodInSemester: 1,
  },
];

const TOOLTIP_PERIODS = {
  period: 'blok',
  periods: 'blokken',
  and: 'en',
};

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Periods',
  component: Periods,
  argTypes: {
    expanded: {
      // Hide the expanded prop. Changing the value in Storybook doesn't update the state of the component.
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: Periods,
    codeString: codeString,
  },
} as Meta<PeriodsProps>;

const Template: StoryFn<PeriodsProps> = (args) => <Periods {...args} />;

export const PeriodsExample = Template.bind({});

PeriodsExample.args = {
  periods: PERIODS,
  maxPeriods: 7,
  tooltipTranslations: TOOLTIP_PERIODS,
};
